const areClausesPresent = clauses =>
  clauses && Object.keys(clauses).length !== 0;

export default areClausesPresent;
